//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SfIcon from "../../atoms/SfIcon/SfIcon.vue";
import SfButton from "../../atoms/SfButton/SfButton.vue";
export default {
  name: "SfNotification",
  components: {
    SfIcon,
    SfButton,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    message: {
      type: String,
      default: "",
    },
    action: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "secondary",
      validator: function (value) {
        return ["secondary", "info", "success", "warning", "danger", "error"].includes(
          value
        );
      },
    },
  },
  computed: {
    icon() {
      switch (this.type) {
        case "success":
          return "check";
        case "danger":
        case "error":
        case "info":
          return "info";
        default:
          return "info";
      }
    },
    iconColor() {
      switch (this.type) {
        case "success":
          return "var(--c-success)";
        case "danger":
        case "error":
          return "var(--c-danger)";
        case "info":
          return "var(--c-info)";
        default:
          return "var(--c-success)";
      }
    }
  },
  methods: {
    actionHandler() {
      this.$emit("click:action");
    },
    closeHandler() {
      this.$emit("click:close");
    },
  },
};
